import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin-squint': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 456c110.3 0 200-89.7 200-200s-89.7-200-200-200-200 89.7-200 200 89.7 200 200 200zM353.6 304.6c10-3.1 19.3 5.5 17.7 15.3-8 47.1-71.3 80-123.3 80s-115.4-32.9-123.3-80c-1.7-9.9 7.8-18.4 17.7-15.3 26 8.3 64.4 13.1 105.6 13.1s79.7-4.8 105.6-13.1zM118.9 263.8c-3.8-4.4-3.9-11-0.1-15.5l33.6-40.3-33.6-40.3c-3.7-4.5-3.7-11 0.1-15.5 3.9-4.4 10.2-5.5 15.3-2.5l80 48c3.6 2.2 5.8 6.1 5.8 10.3s-2.2 8.1-5.8 10.3l-80 48c-5.4 3.2-11.7 1.7-15.3-2.5zM361.8 266.3l-80-48c-3.6-2.2-5.8-6.1-5.8-10.3s2.2-8.1 5.8-10.3l80-48c5.1-2.9 11.5-1.9 15.3 2.5 3.8 4.5 3.9 11 0.1 15.5l-33.6 40.3 33.6 40.3c3.7 4.5 3.7 11-0.1 15.5-3.6 4.2-9.9 5.7-15.3 2.5z'
      }
    ]
  }
})
